import { useState, useEffect } from "react";
import { useQuery } from "@apollo/client";
import { RaceInfoMyBets } from "@tvg/ts-types/Race";
import queryHelper from "../graphql/options.graph";
import { GetAllWagerTypesQueryProps, WagerTypesGraphResponse } from "../types";
import { GET_ALL_WAGER_TYPES } from "../graphql/queries/AllWagerTypes";

const useGetAllWagerTypes = ({
  wagerProfile,
  queryBets
}: GetAllWagerTypesQueryProps) => {
  const [races, setRaces] = useState<RaceInfoMyBets[]>([]);
  const [currentRaceDate, setCurrentRaceDate] = useState<string>("");

  const {
    data,
    loading: isLoadingGraph,
    subscribeToMore: subscribeToMoreGraph
  } = useQuery<WagerTypesGraphResponse>(
    GET_ALL_WAGER_TYPES,
    queryHelper.apolloOptions({ wagerProfile, queryBets })
  );

  useEffect(() => {
    if (data && !isLoadingGraph) {
      setRaces(data.races);
      setCurrentRaceDate(data.raceDate);
    }
  }, [data, isLoadingGraph]);

  return { races, currentRaceDate, isLoadingGraph, subscribeToMoreGraph };
};

export default useGetAllWagerTypes;
